import React from "react";
import { Card, Page, SkeletonBodyText, SkeletonDisplayText, VerticalStack } from "@shopify/polaris";

function DetailsSkeleton() {
  return (
    <Page>
      <VerticalStack gap="8">
        <SkeletonDisplayText />
        <SkeletonBodyText lines={2} />

        <SkeletonDisplayText />
        <Card>
          <Card.Section>
            <SkeletonBodyText lines={6} />
          </Card.Section>
        </Card>

        <SkeletonDisplayText />
        <Card>
          <Card.Section>
            <SkeletonBodyText lines={2} />
          </Card.Section>
        </Card>

        <SkeletonDisplayText />
        <Card>
          <Card.Section>
            <SkeletonBodyText lines={6} />
          </Card.Section>
        </Card>

        <SkeletonDisplayText />
        <Card>
          <Card.Section>
            <SkeletonBodyText lines={6} />
          </Card.Section>
        </Card>
      </VerticalStack>
    </Page>
  );
}

export default DetailsSkeleton;
